var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"0","margin":"0"}},[_c('router-view'),_c('notifications',{attrs:{"group":"notification"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }